import axios from "axios";

import { config } from "shared/data";

import { LayoutVariant } from "scmp-app/pages/home/styles";

interface HomepageCustomWidgetsConfig {
  thingsToDoPromotedByPlus: string;
}

export const getHomePageLayoutVariant = async (): Promise<LayoutVariant> => {
  try {
    const resp = await axios.get<HomepageCustomWidgetsConfig>(
      `https://${config.general.cdn.host}/data/homepage-custom-widgets.json`,
      {
        timeout: 1000,
      },
    );

    return resp?.data?.thingsToDoPromotedByPlus === "on"
      ? LayoutVariant.ThingsToDoPromotedByPlus
      : LayoutVariant.Default;
  } catch (error) {
    console.warn("Failed to fetch homepage layout variant, using default:", error);
    return LayoutVariant.Default;
  }
};
